import { logger } from '../utils/logger';

class FacebookPixel {
  private pixelId: string | null = null;

  init(pixelId: string): void {
    if (!pixelId) {
      logger.error('Facebook Pixel ID is required for initialization');
      return;
    }

    this.pixelId = pixelId;
    this.trigger('init', pixelId);
    this.trigger('track', 'PageView');
    logger.info(`Facebook Pixel initialized with ID: ${this.pixelId}`);
  }

  getPixelId(): string | null {
    return this.pixelId;
  }

  trigger(evt: string, param1: string, param2?: object): void {
    if (!evt || !param1 || !window.fbq || typeof window.fbq !== 'function') {
      logger.error('Facebook Pixel is not available or initialized');
      return;
    }

    param2 ? window.fbq(evt, param1, param2) : window.fbq(evt, param1);
  }

  trackPageView(): void {
    this.trigger('track', 'PageView');
  }

  trackAddToCart(value: number, contents: Array<object>, currency: string): void {
    this.trigger('track', 'AddToCart', {
      currency,
      value,
      contents,
    });
  }

  trackPurchase(totalValue: number, contents: Array<object>, eventId: string, currency: string): void {
    this.trigger('track', 'Purchase', {
      currency,
      value : totalValue,
      contents,
      content_ids : [eventId],
      content_type : 'product',
    });
  }
}

export default new FacebookPixel();
